import { LAVENDER_STEEL } from 'utils/theme';

const DevsIcon = (props) => {
  return (
    <svg
      width={props.width ?? 20}
      height={props.height ?? 20}
      stroke={props.stroke ?? LAVENDER_STEEL}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8.23853L3 12.2385L8 16.2385M16 16.2385L21 12.2385L16 8.23853"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DevsIcon;
